import { RANK_SYMBOLS } from "@/game-lol/constants/constants-ranks.mjs";
import BronzeIcon from "@/inline-assets/lol-rank-bronze.svg";
import ChallengerIcon from "@/inline-assets/lol-rank-challenger.svg";
import DiamondIcon from "@/inline-assets/lol-rank-diamond.svg";
import DiamondPlusIcon from "@/inline-assets/lol-rank-diamond-plus.svg";
import EmeraldIcon from "@/inline-assets/lol-rank-emerald.svg";
import EmeraldPlusIcon from "@/inline-assets/lol-rank-emerald-plus.svg";
import GoldIcon from "@/inline-assets/lol-rank-gold.svg";
import GrandMasterIcon from "@/inline-assets/lol-rank-grandmaster.svg";
import IronIcon from "@/inline-assets/lol-rank-iron.svg";
import MasterIcon from "@/inline-assets/lol-rank-master.svg";
import MasterPlusIcon from "@/inline-assets/lol-rank-master-plus.svg";
import PlatinumIcon from "@/inline-assets/lol-rank-platinum.svg";
import PlatinumPlusIcon from "@/inline-assets/lol-rank-platinum-plus.svg";
import SilverIcon from "@/inline-assets/lol-rank-silver.svg";
import SymbolMap from "@/util/symbol-map.mjs";

export const RANK_SYMBOL_TO_ICON = new SymbolMap({
  [RANK_SYMBOLS.platinumPlus]: PlatinumPlusIcon,
  [RANK_SYMBOLS.challenger]: ChallengerIcon,
  [RANK_SYMBOLS.grandmaster]: GrandMasterIcon,
  [RANK_SYMBOLS.master]: MasterIcon,
  [RANK_SYMBOLS.masterPlus]: MasterPlusIcon,
  [RANK_SYMBOLS.diamond]: DiamondIcon,
  [RANK_SYMBOLS.diamondPlus]: DiamondPlusIcon,
  [RANK_SYMBOLS.emerald]: EmeraldIcon,
  [RANK_SYMBOLS.emeraldPlus]: EmeraldPlusIcon,
  [RANK_SYMBOLS.platinum]: PlatinumIcon,
  [RANK_SYMBOLS.gold]: GoldIcon,
  [RANK_SYMBOLS.silver]: SilverIcon,
  [RANK_SYMBOLS.bronze]: BronzeIcon,
  [RANK_SYMBOLS.iron]: IronIcon,
});
